var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"data-testid":"user-icon-btn","icon":"","dark":"","large":""}},on),[_c('v-avatar',{attrs:{"size":"36"}},[(_vm.user.photoURL)?_c('v-img',{attrs:{"src":_vm.user.photoURL}}):_c('v-icon',[_vm._v("mdi-account-circle")])],1)],1)]}}])},[_c('UserMenuList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }